<template>
  <div class="_container">
    <el-card shadow="never" class="_card">
      <el-form :model="form" :rules="rules" ref="yearForm" :inline="true">
        <el-form-item label="Select Report" prop="year">
          <el-select
            style="width: 300px"
            v-model="form.selectReportId"
            multiple
            :multiple-limit="3"
            @change="handleClickReport"
          >
            <el-option
              v-for="item in selectReportData"
              :key="item.id"
              :label="`${item.reportYear}  ${item.reportQuarter}`"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span style="margin: 0 10px 0 20px">Currency</span>
          <el-select
            v-model="currency"
            @change="handleCurrencyChange"
            size="small"
            class="_selectCurrency"
          >
            <el-option
              v-for="item in currencyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <customize-button
            type="primary"
            @click="handleSearch"
            v-if="isShowSearchBtn"
          >
            Search
          </customize-button>
        </el-form-item>
        <el-form-item>
          <customize-button
            type="primary"
            v-if="isShowComparisonBtn"
            @click="handleClickComparisonViewBtn"
          >
            Comparison View
          </customize-button>
        </el-form-item>
      </el-form>
      <el-row :gutter="24" v-if="isShowSearchBtn">
        <el-col :span="8" class="col_row">
          <span>Data Source:</span>
          <span>{{ dataSource }}</span>
        </el-col>
        <el-col :span="8" class="col_row">
          <span>Account Type：</span>
          <span>{{ filterNameAccountType(accountType) }}</span>
        </el-col>
        <el-col :span="8" class="col_row">
          <span>Auditors'opinion：</span>
          <span>{{ filterNameAuditorsOpinion(auditorsOpinion) }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="24" v-if="this.isSelectedReportIds.length > 1">
        <el-col :span="6" class="col_margin">
          <span>Select Report</span>
        </el-col>
        <el-col :span="6" class="col_margin">
          <span>Data Source</span>
        </el-col>
        <el-col :span="6" class="col_margin">
          <span>Account Type</span>
        </el-col>
        <el-col :span="6" class="col_margin">
          <span>Auditors'opinion</span>
        </el-col>
      </el-row>
      <template v-if="this.isSelectedReportIds.length > 1">
        <el-row
          :gutter="24"
          v-for="(item, index) in this.selectedReportArr"
          :key="index"
        >
          <el-col :span="6" class="col_margin">
            <span>{{ `${item.reportYear}  ${item.reportQuarter}` }}</span>
          </el-col>
          <el-col :span="6" class="col_margin">
            <span>{{ item.attachmentId ? 'Linkredit' : 'CRMZ' }}</span>
          </el-col>
          <el-col :span="6" class="col_margin">
            <span>{{ filterNameAccountType(item.accountType) }}</span>
          </el-col>
          <el-col :span="6" class="col_margin">
            <span>{{ filterNameAuditorsOpinion(item.auditorsOpinion) }}</span>
          </el-col>
        </el-row>
      </template>
    </el-card>
    <el-card class="_card" shadow="never">
      <div class="actionBtn">
        <el-popover
          class="popover_class"
          placement="top-start"
          trigger="hover"
          content="Average of same Business Type in same Sales Country"
          v-if="isMultiple"
        >
          <el-checkbox
            slot="reference"
            v-model="isAverageData"
            @change="handleClickAverage"
          >
            Average Data
          </el-checkbox>
        </el-popover>

        <customize-button type="primary" @click="handleExportData">
          Download
        </customize-button>
      </div>
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="Income Statement" name="one">
          <financial-chart
            v-for="item in chartData"
            :key="item.field"
            :chartData="item"
            :field="item.field"
            :fieldName="item.fieldName"
          />
          <div
            v-for="item in financeIncomes && financeIncomes.length"
            :key="item"
          >
            <table-view
              ref="incomeTable"
              :showPage="false"
              :tableModel="tableIOModel(financeIncomes[item - 1])"
              :tableData="tableIOData(financeIncomes[item - 1])"
            >
              <template v-slot:key0="{ tableRow }">
                <a
                  style="font-weight: bold"
                  v-if="oneKeys.indexOf(tableRow.row.key0) !== -1"
                >
                  {{ tableRow.row.key0 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key0 }}
                </a>
              </template>
              <template v-slot:key3="{ tableRow }" v-if="colorId === 2">
                <a style="color: red" v-if="Number(tableRow.row.key3) < 0">
                  {{ tableRow.row.key3 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key3 }}
                </a>
              </template>
              <template v-slot:key4="{ tableRow }" v-if="colorId === 3">
                <a style="color: red" v-if="Number(tableRow.row.key4) < 0">
                  {{ tableRow.row.key4 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key4 }}
                </a>
              </template>
              <template v-slot:action="{ tableRow }">
                <a
                  v-if="existedKeys.indexOf(tableRow.row.key0) === -1"
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleChart(tableRow)"
                >
                  Chart
                </a>
                <a
                  v-else
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleReplace(tableRow.row)"
                >
                  Take Down
                </a>
                <!-- 因为不同的tab中,key会有相同的情况(所以使用v-if来区分4个tab)-->
                <!-- v-if="oneKeys.indexOf(tableRow.row.key) === -1" -->
                <a
                  href="javascript:;"
                  v-if="oneKeys.indexOf(tableRow.row.key0) === -1"
                  style="margin-right: 20px"
                  @click="_handleEdit(tableRow, item, activeTab)"
                >
                  Edit
                </a>
              </template>
            </table-view>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Balance Sheet" name="two">
          <financial-chart
            v-for="item in chartData"
            :key="item.field"
            :chartData="item"
            :field="item.field"
            :fieldName="item.fieldName"
          />
          <div style="display: flex">
            <p style="margin-right: 20px">Balance Sheet</p>
            <div
              style="
                display: flex;
                flex-direction: column;
                gap: 10px;
                font-size: 12px;
                color: red;
              "
            >
              <span v-for="(item, index) in notifications" :key="index">
                {{ item }}
              </span>
            </div>
          </div>
          <div
            v-for="item in financeBalances && financeBalances.length"
            :key="item"
          >
            <table-view
              ref="incomeTable"
              :showPage="false"
              :tableModel="tableIOModel(financeBalances[item - 1])"
              :tableData="tableIOData(financeBalances[item - 1])"
            >
              <template v-slot:key0="{ tableRow }">
                <a
                  style="font-weight: bold"
                  v-if="twoKeys.indexOf(tableRow.row.key0) !== -1"
                >
                  {{ tableRow.row.key0 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key0 }}
                </a>
              </template>
              <template v-slot:key3="{ tableRow }" v-if="colorId === 2">
                <a style="color: red" v-if="Number(tableRow.row.key3) < 0">
                  {{ tableRow.row.key3 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key3 }}
                </a>
              </template>
              <template v-slot:key4="{ tableRow }" v-if="colorId === 3">
                <a style="color: red" v-if="Number(tableRow.row.key4) < 0">
                  {{ tableRow.row.key4 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key4 }}
                </a>
              </template>
              <template v-slot:action="{ tableRow }">
                <a
                  v-if="existedKeys.indexOf(tableRow.row.key0) === -1"
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleChart(tableRow)"
                >
                  Chart
                </a>
                <a
                  v-else
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleReplace(tableRow.row)"
                >
                  Take Down
                </a>
                <a
                  href="javascript:;"
                  v-if="twoKeys.indexOf(tableRow.row.key0) === -1"
                  style="margin-right: 20px"
                  @click="_handleEdit(tableRow, item, activeTab)"
                >
                  Edit
                </a>
              </template>
            </table-view>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Cash Flow" name="four">
          <financial-chart
            v-for="item in chartData"
            :key="item.field"
            :chartData="item"
            :field="item.field"
            :fieldName="item.fieldName"
          />
          <p>Cash Flow</p>

          <div v-for="item in cashflows && cashflows.length" :key="item">
            <table-view
              ref="incomeTable"
              :showPage="false"
              :tableModel="tableIOModel(cashflows[item - 1])"
              :tableData="tableIOData(cashflows[item - 1])"
            >
              <template v-slot:key0="{ tableRow }">
                <a
                  style="font-weight: bold"
                  v-if="threeKeys.indexOf(tableRow.row.key0) !== -1"
                >
                  {{ tableRow.row.key0 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key0 }}
                </a>
              </template>
              <template v-slot:key3="{ tableRow }" v-if="colorId === 2">
                <a style="color: red" v-if="Number(tableRow.row.key3) < 0">
                  {{ tableRow.row.key3 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key3 }}
                </a>
              </template>
              <template v-slot:key4="{ tableRow }" v-if="colorId === 3">
                <a style="color: red" v-if="Number(tableRow.row.key4) < 0">
                  {{ tableRow.row.key4 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key4 }}
                </a>
              </template>
              <template v-slot:action="{ tableRow }">
                <a
                  v-if="existedKeys.indexOf(tableRow.row.key0) === -1"
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleChart(tableRow)"
                >
                  Chart
                </a>
                <a
                  v-else
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleReplace(tableRow.row)"
                >
                  Take Down
                </a>
                <a
                  href="javascript:;"
                  v-if="threeKeys.indexOf(tableRow.row.key0) === -1"
                  style="margin-right: 20px"
                  @click="_handleEdit(tableRow, item, activeTab)"
                >
                  Edit
                </a>
              </template>
            </table-view>
          </div>
        </el-tab-pane>
        <el-tab-pane label="Financial Ratios" name="three">
          <financial-chart
            v-for="item in chartData"
            :key="item.field"
            :chartData="item"
            :field="item.field"
            :fieldName="item.fieldName"
          />
          <p>Financial Ratios</p>
          <div
            v-for="item in financeRatios && financeRatios.length"
            :key="item"
          >
            <table-view
              ref="incomeTable"
              :showPage="false"
              :tableModel="tableIOModel(financeRatios[item - 1])"
              :tableData="tableIOData(financeRatios[item - 1])"
            >
              <template v-slot:key0="{ tableRow }">
                <a
                  style="font-weight: bold"
                  v-if="fourKeys.indexOf(tableRow.row.key0) !== -1"
                >
                  {{ tableRow.row.key0 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key0 }}
                </a>
              </template>
              <template v-slot:key3="{ tableRow }" v-if="colorId === 2">
                <a style="color: red" v-if="Number(tableRow.row.key3) < 0">
                  {{ tableRow.row.key3 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key3 }}
                </a>
              </template>
              <template v-slot:key4="{ tableRow }" v-if="colorId === 3">
                <a style="color: red" v-if="Number(tableRow.row.key4) < 0">
                  {{ tableRow.row.key4 }}
                </a>
                <a v-else>
                  {{ tableRow.row.key4 }}
                </a>
              </template>
              <template v-slot:action="{ tableRow }">
                <a
                  v-if="existedKeys.indexOf(tableRow.row.key0) === -1"
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleChart(tableRow)"
                >
                  Chart
                </a>
                <a
                  v-else
                  href="javascript:;"
                  style="display: inline-block; margin-right: 20px; width: 70px"
                  @click="_handleReplace(tableRow.row)"
                >
                  Take Down
                </a>
              </template>
            </table-view>
          </div>
        </el-tab-pane>
        <el-tab-pane label="AI Analysis" name="five">
          <div style="display: flex; justify-content: flex-end; margin-top: 20px; gap: 12px;">
            <customize-button
              type="primary"
              @click="generatePDF"
              :loading="isDownloading"
            >
              Generate PDF
            </customize-button>
            <customize-button
              type="primary"
              @click="handleCallAIInterface"
              :disabled="isAiButtonDisabled"
            >
              Update AI Analysis
            </customize-button>
          </div>
          <div ref="aiAnalysisContent">
          <div v-if="parsedAiAnalysis()" style="padding: 20px 0">
            <!-- Warning Reason Card -->
            <div
              style="
                background: #fff;
                border: 1px solid #e5e7eb;
                border-radius: 12px;
                padding: 24px;
                margin-bottom: 20px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
              "
            >
              <div
                style="display: flex; align-items: center; margin-bottom: 16px"
              >

                <div
                  style="
                    width: 32px;
                    height: 32px;
                    background: #f97316;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 12px;
                  "
                >
                  <span style="color: white; font-size: 16px">⚠️</span>
                </div>
                <h3
                  style="
                    margin: 0;
                    color: #111827;
                    font-size: 18px;
                    font-weight: 600;
                  "
                >
                  Warning Reason
                </h3>
              </div>
              <div style="color: #4b5563; line-height: 1.6">
                <div
                  v-if="analysisAiVO.earlyWarningReason"
                  v-html="formatText(analysisAiVO.earlyWarningReason)"
                ></div>
              </div>
            </div>

            <!-- AI Analysis Conclusion Card -->
            <div
              style="
                background: #fff;
                border: 1px solid #e5e7eb;
                border-radius: 12px;
                padding: 24px;
                margin-bottom: 20px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
              "
            >
              <div
                style="display: flex; align-items: center; margin-bottom: 16px"
              >
                <div
                  style="
                    width: 32px;
                    height: 32px;
                    background: #ec4899;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 12px;
                  "
                >
                  <span style="color: white; font-size: 16px">🎯</span>
                </div>
                <h3
                  style="
                    margin: 0;
                    color: #111827;
                    font-size: 18px;
                    font-weight: 600;
                  "
                >
                  AI Analysis Conclusion
                </h3>
              </div>
              <div style="color: #4b5563; line-height: 1.6">
<!--                The company has a gross profit margin of 8.62%, operating profit-->
<!--                margin of 2.63%, and a net profit margin of 2.53%. The financial-->
<!--                position appears stable with total assets equaling total-->
<!--                liabilities and equity. [Currency Conversion: All values have-->
<!--                been converted from KRW to USD at rate 0.0007-->
                {{ parsedAiAnalysisConclusion() }}
              </div>
            </div>

            <!-- Credit Risk Analysis Header -->
            <div style="text-align: center; margin: 40px 0 30px 0">
              <div
                style="
                  border-top: 4px solid #9ca3af;
                  width: 100%;
                  position: relative;
                "
              >
                <h2
                  style="
                    background: #f9fafb;
                    color: #374151;
                    font-size: 20px;
                    font-weight: 700;
                    margin: 0;
                    padding: 16px 0;
                    letter-spacing: 2px;
                  "
                >
                  CREDIT RISK ANALYSIS
                </h2>
                <div
                  style="border-bottom: 4px solid #9ca3af; width: 100%"
                ></div>
              </div>
            </div>

            <!-- Highlights Summary Card -->
            <div
              style="
                background: #fff;
                border: 1px solid #e5e7eb;
                border-radius: 12px;
                padding: 24px;
                margin-bottom: 20px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
              "
            >
              <div
                style="display: flex; align-items: center; margin-bottom: 16px"
              >
                <div
                  style="
                    width: 32px;
                    height: 32px;
                    background: #eab308;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 12px;
                  "
                >
                  <span style="color: white; font-size: 16px">⭐</span>
                </div>
                <h3
                  style="
                    margin: 0;
                    color: #111827;
                    font-size: 18px;
                    font-weight: 600;
                  "
                >
                  Highlights Summary
                </h3>
              </div>
              <div style="color: #4b5563; line-height: 1.6">
                {{ parsedAiAnalysis().highlights_summary }}
              </div>
            </div>

            <!-- Company Information Card -->
            <div
              style="
                background: #fff;
                border: 1px solid #e5e7eb;
                border-radius: 12px;
                padding: 24px;
                margin-bottom: 20px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
              "
            >
              <div
                style="display: flex; align-items: center; margin-bottom: 16px"
              >
                <div
                  style="
                    width: 32px;
                    height: 32px;
                    background: #3b82f6;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 12px;
                  "
                >
                  <span style="color: white; font-size: 16px">🏢</span>
                </div>
                <h3
                  style="
                    margin: 0;
                    color: #111827;
                    font-size: 18px;
                    font-weight: 600;
                  "
                >
                  Company Information
                </h3>
              </div>
              <div
                style="
                  display: grid;
                  grid-template-columns: repeat(4, 1fr);
                  gap: 16px;
                "
              >
                <div>
                  <div
                    style="font-weight: 500; color: #374151; margin-bottom: 4px"
                  >
                    Company Name
                  </div>
                  <div style="color: #4b5563">
                    {{ analysisAiVO.companyName || 'Unknown Company' }}
                  </div>
                </div>
                <!-- <div>
                  <div
                    style="font-weight: 500; color: #374151; margin-bottom: 4px"
                  >
                    Industry
                  </div>
                  <div style="color: #4b5563">
                    {{
                      parsedAiAnalysis().customer_info?.industry ||
                      'Not specified due to lack of financial data.'
                    }}
                  </div>
                </div> -->
                <div>
                  <div
                    style="font-weight: 500; color: #374151; margin-bottom: 4px"
                  >
                    Region
                  </div>
                  <div style="color: #4b5563">
                    {{
                      analysisAiVO.region ||
                      'Not specified due to lack of financial data.'
                    }}
                  </div>
                </div>
                <!-- <div>
                  <div
                    style="font-weight: 500; color: #374151; margin-bottom: 4px"
                  >
                    Currency
                  </div>
                  <div style="color: #4b5563">
                    {{ parsedAiAnalysis().currency || 'USD' }}
                  </div>
                </div> -->
              </div>
            </div>

            <!-- Financial Analysis Card -->
            <div
              style="
                background: #fff;
                border: 1px solid #e5e7eb;
                border-radius: 12px;
                padding: 24px;
                margin-bottom: 20px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
              "
            >
              <div
                style="display: flex; align-items: center; margin-bottom: 16px"
              >
                <div
                  style="
                    width: 32px;
                    height: 32px;
                    background: #059669;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 12px;
                  "
                >
                  <span style="color: white; font-size: 16px">📊</span>
                </div>
                <h3
                  style="
                    margin: 0;
                    color: #111827;
                    font-size: 18px;
                    font-weight: 600;
                  "
                >
                  Financial Analysis
                </h3>
              </div>

              <div
                style="display: grid; grid-template-columns: 1fr 1fr; gap: 24px"
              >
                <!-- Business Scale -->
                <div>
                  <h4
                    style="color: #374151; font-weight: 600; margin-bottom: 8px"
                  >
                    Business Scale
                  </h4>
                  <div
                    style="color: #4b5563; line-height: 1.6; font-size: 14px"
                  >
                    {{ parsedAiAnalysis().financial_analysis?.business_scale }}
                  </div>
                </div>

                <!-- Leverage -->
                <div>
                  <h4
                    style="color: #374151; font-weight: 600; margin-bottom: 8px"
                  >
                    Leverage
                  </h4>
                  <div
                    style="color: #4b5563; line-height: 1.6; font-size: 14px"
                  >
                    {{ parsedAiAnalysis().financial_analysis?.leverage }}
                  </div>
                </div>

                <!-- Liquidity -->
                <div>
                  <h4
                    style="color: #374151; font-weight: 600; margin-bottom: 8px"
                  >
                    Liquidity
                  </h4>
                  <div
                    style="color: #4b5563; line-height: 1.6; font-size: 14px"
                  >
                    {{ parsedAiAnalysis().financial_analysis?.liquidity }}
                  </div>
                </div>

                <!-- Cash Flow -->
                <div>
                  <h4
                    style="color: #374151; font-weight: 600; margin-bottom: 8px"
                  >
                    Cash Flow
                  </h4>
                  <div
                    style="color: #4b5563; line-height: 1.6; font-size: 14px"
                  >
                    {{ parsedAiAnalysis().financial_analysis?.cash_flow }}
                  </div>
                </div>

                <!-- Profitability (full width) -->
                <div style="grid-column: span 2">
                  <h4
                    style="color: #374151; font-weight: 600; margin-bottom: 8px"
                  >
                    Profitability
                  </h4>
                  <div
                    style="color: #4b5563; line-height: 1.6; font-size: 14px"
                  >
                    {{ parsedAiAnalysis().financial_analysis?.profitability }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Key Strengths and Key Weaknesses -->
            <div
              style="
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 20px;
                margin-bottom: 20px;
              "
            >
              <!-- Key Strengths -->
              <div
                style="
                  background: #fff;
                  border: 1px solid #e5e7eb;
                  border-radius: 12px;
                  padding: 24px;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                  "
                >
                  <div
                    style="
                      width: 32px;
                      height: 32px;
                      background: #10b981;
                      border-radius: 8px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      margin-right: 12px;
                    "
                  >
                    <span style="color: white; font-size: 16px">✅</span>
                  </div>
                  <h3
                    style="
                      margin: 0;
                      color: #111827;
                      font-size: 18px;
                      font-weight: 600;
                    "
                  >
                    Key Strengths
                  </h3>
                </div>
                <div
                  v-if="
                    parsedAiAnalysis().key_strengths &&
                    parsedAiAnalysis().key_strengths.length > 0
                  "
                >
                  <div
                    v-for="(strength, index) in parsedAiAnalysis()
                      .key_strengths"
                    :key="index"
                    style="
                      color: #4b5563;
                      margin-bottom: 8px;
                      display: flex;
                      align-items: flex-start;
                    "
                  >
                    <span
                      style="color: #10b981; margin-right: 8px; margin-top: 2px"
                    >
                      ●
                    </span>
                    <span style="line-height: 1.6">{{ strength }}</span>
                  </div>
                </div>
                <div v-else style="color: #9ca3af; font-style: italic">
                  No specific strengths identified in current analysis.
                </div>
              </div>

              <!-- Key Weaknesses -->
              <div
                style="
                  background: #fff;
                  border: 1px solid #e5e7eb;
                  border-radius: 12px;
                  padding: 24px;
                  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                "
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                  "
                >
                  <div
                    style="
                      width: 32px;
                      height: 32px;
                      background: #ef4444;
                      border-radius: 8px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      margin-right: 12px;
                    "
                  >
                    <span style="color: white; font-size: 16px">❌</span>
                  </div>
                  <h3
                    style="
                      margin: 0;
                      color: #111827;
                      font-size: 18px;
                      font-weight: 600;
                    "
                  >
                    Key Weaknesses
                  </h3>
                </div>
                <div
                  v-if="
                    parsedAiAnalysis().key_weaknesses &&
                    parsedAiAnalysis().key_weaknesses.length > 0
                  "
                >
                  <div
                    v-for="(weakness, index) in parsedAiAnalysis()
                      .key_weaknesses"
                    :key="index"
                    style="
                      color: #4b5563;
                      margin-bottom: 8px;
                      display: flex;
                      align-items: flex-start;
                    "
                  >
                    <span
                      style="color: #ef4444; margin-right: 8px; margin-top: 2px"
                    >
                      ●
                    </span>
                    <span style="line-height: 1.6">{{ weakness }}</span>
                  </div>
                </div>
                <div v-else style="color: #9ca3af; font-style: italic">
                  No specific weaknesses identified in current analysis.
                </div>
              </div>
            </div>

            <!-- Recommendations Card -->
            <div
              style="
                background: #fff;
                border: 1px solid #e5e7eb;
                border-radius: 12px;
                padding: 24px;
                margin-bottom: 20px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
              "
            >
              <div
                style="display: flex; align-items: center; margin-bottom: 16px"
              >
                <div
                  style="
                    width: 32px;
                    height: 32px;
                    background: #6366f1;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 12px;
                  "
                >
                  <span style="color: white; font-size: 16px">💡</span>
                </div>
                <h3
                  style="
                    margin: 0;
                    color: #111827;
                    font-size: 18px;
                    font-weight: 600;
                  "
                >
                  Recommendations
                </h3>
              </div>
              <div
                v-if="
                  parsedAiAnalysis().recommendations &&
                  parsedAiAnalysis().recommendations.length > 0
                "
              >
                <div
                  v-for="(recommendation, index) in parsedAiAnalysis()
                    .recommendations"
                  :key="index"
                  style="
                    color: #4b5563;
                    margin-bottom: 12px;
                    display: flex;
                    align-items: flex-start;
                  "
                >
                  <span
                    style="
                      color: #6366f1;
                      margin-right: 8px;
                      margin-top: 2px;
                      font-weight: 600;
                    "
                  >
                    {{ index + 1 }}.
                  </span>
                  <span style="line-height: 1.6">{{ recommendation }}</span>
                </div>
              </div>
              <div v-else style="color: #9ca3af; font-style: italic">
                No specific recommendations available.
              </div>
            </div>

            <!-- Credit Scorecards Card -->
            <!-- <div
              style="
                background: #fff;
                border: 1px solid #e5e7eb;
                border-radius: 12px;
                padding: 24px;
                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
              "
            >
              <div
                style="display: flex; align-items: center; margin-bottom: 16px"
              >
                <div
                  style="
                    width: 32px;
                    height: 32px;
                    background: #8b5cf6;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-right: 12px;
                  "
                >
                  <span style="color: white; font-size: 16px">📈</span>
                </div>
                <h3
                  style="
                    margin: 0;
                    color: #111827;
                    font-size: 18px;
                    font-weight: 600;
                  "
                >
                  Credit Scorecards
                </h3>
              </div>
              <div
                style="
                  display: grid;
                  grid-template-columns: repeat(3, 1fr);
                  gap: 24px;
                  text-align: center;
                "
              >
                <div>
                  <div
                    style="font-weight: 600; color: #374151; margin-bottom: 8px"
                  >
                    Z-Score
                  </div>
                  <div
                    style="font-size: 24px; font-weight: 700; color: #6b7280"
                  >
                    {{ parsedAiAnalysis().scorecards?.z_score || 'N/A' }}
                  </div>
                  <div style="color: #9ca3af; font-size: 12px">
                    {{
                      parsedAiAnalysis().scorecards?.z_score
                        ? ''
                        : 'Not available'
                    }}
                  </div>
                </div>
                <div>
                  <div
                    style="font-weight: 600; color: #374151; margin-bottom: 8px"
                  >
                    GCR Rating
                  </div>
                  <div
                    style="font-size: 24px; font-weight: 700; color: #6b7280"
                  >
                    {{ parsedAiAnalysis().scorecards?.gcr || 'N/A' }}
                  </div>
                  <div style="color: #9ca3af; font-size: 12px">
                    Not available
                  </div>
                </div>
                <div>
                  <div
                    style="font-weight: 600; color: #374151; margin-bottom: 8px"
                  >
                    Regional Score
                  </div>
                  <div
                    style="font-size: 24px; font-weight: 700; color: #6b7280"
                  >
                    {{
                      parsedAiAnalysis().scorecards?.region_scorecard || 'N/A'
                    }}
                  </div>
                  <div style="color: #9ca3af; font-size: 12px">
                    Not available
                  </div>
                </div>
              </div>
            </div> -->
          </div>

          <!-- Loading or No Data State -->
          <div
            v-else
            style="text-align: center; padding: 60px 20px; color: #9ca3af"
          >
            <div style="font-size: 48px; margin-bottom: 16px">🤖</div>
            <h3 style="margin: 0 0 8px 0; color: #6b7280">
              AI Analysis Not Available
            </h3>
            <p style="margin: 0">
              Please ensure financial data is available and try again.
            </p>
          </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    <!--弹窗-->
    <el-dialog
      :close-on-click-modal="false"
      title="Edit"
      :visible.sync="showDialog"
      width="30%"
      @close="_handleEditClose"
    >
      <el-form>
        <el-form-item
          v-for="(item, index) in editDialogForm"
          :label="`year ${item.label}`"
          :key="index"
        >
          <el-input v-model="item.value"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="_handleEditCancel">Cancel</el-button>
        <el-button type="primary" @click="_handleConfirm">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Exchange Rate"
      :visible.sync="isShowExchangeRate"
      width="700px"
    >
      <el-form>
        <el-form-item label="Currency" prop="currency">
          <el-select
            v-model="modelForm.currency"
            style="width: 100%"
            filterable
            disabled
          >
            <el-option
              v-for="item in this.selectCurrencyList"
              :label="item.currencyName"
              :value="item.currency"
              :key="item.currency"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Exchange Date" v-if="form.currency !== 'USD'">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="modelForm.exchangeDate"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="Exchange Rate(USD)" v-if="form.currency !== 'USD'">
          <el-input
            :disabled="true"
            v-model="modelForm.exchangeRate"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowExchangeRate = false">Cancel</el-button>
        <el-button type="primary" @click="handleClickCalcRate">
          Confirm
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Update AI Analysis"
      :visible.sync="showAiUpdateDialog"
      width="500px"
    >
      <el-form>
        <el-form-item label="Select Report">
          <el-select
            v-model="aiUpdateForm.reportIds"    style="width: 100%"
            placeholder="Please select a report"
            multiple
            :multiple-limit="3"
          >
            <el-option
              v-for="item in selectReportData"
              :key="item.id"
              :label="`${item.reportYear} ${item.reportQuarter}`"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Currency">
          <el-select
            v-model="aiUpdateForm.currency"
            style="width: 100%"
            placeholder="Please select currency"
          >
            <el-option
              v-for="item in currencyList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
    <el-button @click="showAiUpdateDialog = false">Cancel</el-button>
    <el-button type="primary" @click="handleAiUpdateSubmit">Submit</el-button>
  </span>
    </el-dialog>

  </div>
</template>

<script>
import FinancialChart from './components/financial-chart'
import dayjs from 'dayjs'
import { cloneDeep } from 'lodash/lang'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
import {
  getTheChart,
  getReportTableData,
  getMultipleData,
  downLoadSelectReport,
  editData,
  callAIInterface,
} from './api'
import {
  getCurrencyList,
  getCurrenyRate,
} from 'views/customer-mangement/detail/financial-report/api'

export default {
  name: 'financial-analysis',
  components: {
    FinancialChart,
  },
  data() {
    const rules = {}
    return {
      activeTab: 'one',
      form: {
        year: `${dayjs().year()}`,
        selectReportId: [],
      },
      rules,
      isAiButtonDisabled: false,
      showAiUpdateDialog: false,
      isDownloading: false,
      aiUpdateForm: {// AI更新表单数据
        reportIds: [],
        currency: '',
      },
      // 图表数据
      cashflows: [],
      financeBalances: [],
      financeIncomes: [],
      financeRatios: [],
      chartData: [], // 三个图表的data
      tableModel: [], // 抽出table model, table data
      // tableIOModel: [],
      tableData: [],
      existedKeys: [],
      tableYears: [],
      showDialog: false,
      editForm: {},
      editRules: {},
      curObj: null,
      oneKeys: [
        'Total Sales',
        'Total Cost of Goods*',
        'Gross Profit',
        'Total Operating Expenses',
        'Optg. Income Bef. Other Inc/Exp. Int. and Taxes',
        'Income From Oper. Bef. Income Taxes',
        'Operating Profit After Tax',
        'Total Extraordinary Items',
        'Net Income',
      ],
      twoKeys: [
        'Total Inventory*',
        'Total Current Assets',
        'Gross Fixed Assets',
        'Net Fixed Assets',
        'Total Non Current Assets',
        'Total Intangibles',
        'Total Assets',
        'Total Current Liabilities',
        'Total Non Current Liabilities',
        'Total Liabilities',
        "Total Owner's Equity",
        "Total Liabilities and Owner's Equity (Total Liab. and O/E)",
      ],
      threeKeys: [
        'Net Cash provided (used) by Operating Activities',
        'Net Cash provided (used) by Investing Activities',
        'Net Cash provided (used) by Financing Activities',
        'Net Cash provided (used) by all above activities',
      ],
      blod: false,
      fourKeys: [
        'Net Cash provided (used) by Operating Activities',
        'Net Cash provided (used) by Investing Activities',
        'Net Cash provided (used) by Financing Activities',
        'Net Cash provided (used) by all above activities',
      ],
      currency: '',
      isShowExchangeRate: false,
      selectReportData: [],
      QList: [
        {
          id: 5,
          name: 'H1',
        },
        {
          id: 6,
          name: 'H2',
        },
        {
          id: 1,
          name: 'Q1',
        },
        {
          id: 2,
          name: 'Q2',
        },
        {
          id: 3,
          name: 'Q3',
        },
        {
          id: 4,
          name: 'Q4',
        },
      ],
      isShowComparisonBtn: false,
      isShowSearchBtn: true,
      isSelectedReportIds: [],
      currencyList: [],
      isAverageData: false,
      newArrDateAll: [],
      dataSource: '',
      colorId: '',
      accountType: '',
      auditorsOpinion: '',
      tableIOALLData: [],
      isMultiple: true,
      conversionRate: '1.0',
      selectCurrencyList: [],
      modelForm: { exchangeDate: '', currency: '', exchangeRate: '' },
      selectedReportArr: [],
      editDialogForm: [],
      notifications: [],
      analysisAiVO: {},
      tablePage: {},
    }
  },
  async mounted() {
    this.fieldName = ''
    await this._getTableData()
    if (this.selectReportData.length) {
      await this.getAllData()
    }
    await this._getCurrencyList()

    if (this.tablePage.total !== 0) {
      await this._getAiAnalysis()
    }
  },
  watch: {
    modelForm: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.currency && val.exchangeDate) {
          this._getCurrenyRate()
        }
      },
    },
  },
  methods: {
    generatePDF() {
      this.isDownloading = true
      let ref = this.$refs.aiAnalysisContent
      const customerId = this.$route.params.customerId || 'Customer'
      const fileName = `AI_Analysis_${customerId}.pdf`

      html2canvas(ref, {
        backgroundColor: '#ffffff',
        scale: 2,
        useCORS: true,
        logging: false,
      })
        .then(canvas => {
          // canvas宽度
          let contentWidth = canvas.width
          // canvas高度
          let contentHeight = canvas.height
          // 一页pdf html页面生成的canvas高度
          let pageHeight = (contentWidth / 592.28) * 841.89
          let leftHeight = contentHeight
          let position = 0
          // a4纸的尺寸[592.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          let imgWidth = 595.28
          let imgHeight = (592.28 / contentWidth) * contentHeight
          let pageData = canvas.toDataURL('image/jpeg', 1.0)
          let PDF = new JsPDF('', 'pt', 'a4')

          // 当内容未超过pdf一页显示的范围，无需分页
          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              // 避免添加空白页
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }

          PDF.save(fileName)
          this.isDownloading = false

          this.$message({
            message: 'PDF generated successfully',
            type: 'success',
          })
        })
        .catch(() => {
          this.isDownloading = false
          this.$message({
            message: 'Images generated failure',
            type: 'error',
          })
        })
    },
    async _getAiAnalysis() {
      const result = await getMultipleData({
        type: 5,
        financeId: this.form.selectReportId[0],
      })
      this.analysisAiVO = result.analysisAiVO
    },
    // 解析AI分析JSON数据
    parsedAiAnalysis() {
      const raw = this.analysisAiVO && this.analysisAiVO.aiFinancialAnalysis
      if (!raw) return null

      // If already an object, return as-is
      if (typeof raw === 'object') return raw

      // If string, try to parse JSON; if fails, return a fallback object containing raw text
      if (typeof raw === 'string') {
        try {
          return JSON.parse(raw)
        } catch (error) {
          console.error('Failed to parse AI analysis data:', error)
          // decode HTML entities/newlines if needed
          const text = this.decodeHtmlEntities(raw)
          return {
            // provide fields the template expects so UI can still render meaningful content
            highlights_summary: text,
            financial_analysis: {
              business_scale: '',
              leverage: '',
              liquidity: '',
              cash_flow: '',
              profitability: '',
            },
            customer_info: {},
            key_strengths: [],
            key_weaknesses: [],
            recommendations: [],
            scorecards: {},
            // keep raw for debugging
            _rawText: text,
          }
        }
      }

      return null
    },
    parsedAiAnalysisConclusion(){
      if (!this.analysisAiVO.aiAnalysisConclusion) return null
      return this.analysisAiVO.aiAnalysisConclusion
    },
    // 格式化分析内容，为指定字段添加icon和加粗样式
    formatAnalysisContent(text) {
      if (!text) return ''

      const fieldConfig = {
        'Highlights Summary': '✨',
        'Lowlights Summary': '⚠️',
        'Internal Info': 'ℹ️',
        'Financial Analysis': '📊',
        'Customer Info': '👥',
        Scorecards: '📋',
        'Risk Mitigation': '🛡️',
        'Ratios Calculated': '🔢',
      }

      let formattedText = text

      // 为每个配置的字段添加icon和加粗样式
      Object.entries(fieldConfig).forEach(([field, icon]) => {
        // 匹配 **字段** 或者单独的字段
        const pattern = new RegExp(
          `\\*\\*\\s*(${field})\\s*\\*\\*|(${field})`,
          'gi',
        )
        formattedText = formattedText.replace(
          pattern,
          `<div style="display: flex; align-items: center; margin: 16px 0 8px 0; font-weight: 700; font-size: 16px; color: #2c3e50;">
            <span style="margin-right: 8px; font-size: 18px;">${icon}</span>
            <span>${field}</span>
          </div>`,
        )
      })

      return formattedText
    },
    // 解码HTML实体并处理换行符
    decodeHtmlEntities(text) {
      if (!text) return ''

      // 创建一个临时元素来解码HTML实体
      const textarea = document.createElement('textarea')
      textarea.innerHTML = text
      let decoded = textarea.value

      // 处理换行符
      decoded = decoded.replace(/\/n/g, '\n')

      return decoded
    },
    // 格式化文本：处理换行符和 HTML 实体
    formatText(text) {
      if (!text) return ''

      // 首先解码 HTML 实体（如 &lt; 转为 <）
      const textarea = document.createElement('textarea')
      textarea.innerHTML = text
      let formatted = textarea.value

      // 处理各种换行符格式：\n, /n, \\n
      formatted = formatted
        .replace(/\\n/g, '<br>') // 转义的 \n
        .replace(/\/n/g, '<br>') // 斜杠 /n
        .replace(/\n/g, '<br>') // 实际换行符

      return formatted
    },
    // 处理数据
    tableIOData(data) {
      const arrDate = cloneDeep(data)
      const newArrDateAll = []
      for (let index = 1; index < arrDate.length; index++) {
        const s = Object.keys(arrDate[index])[0]
        const oneValue = arrDate[index][s]
        oneValue.unshift(s)
        const newArrDate = oneValue.map((value, index) => ({
          value: 'key' + index,
          label: value,
        }))
        newArrDate.map(item => {
          if (item.value !== 'key0') {
            item.label = this.$utils.formatAmount2(item.label)
          }
        })
        let obj = {}
        newArrDate.forEach(item => {
          obj[item.value] = item.label
        })
        newArrDateAll.push(obj)
      }
      return newArrDateAll
    },
    // 处理表头
    tableIOModel(data) {
      const arr = cloneDeep(data[0])
      const s = Object.keys(arr)[0]
      const oneValue = arr[s]
      oneValue.unshift(s)
      const newArr = oneValue.map((value, index) => ({
        prop: 'key' + index,
        label: value,
      }))
      newArr[0].slotName = newArr[0].prop
      newArr[0].width = '350px'
      if (this.form.selectReportId.length === 2 && this.colorId === 2) {
        newArr[3].slotName = newArr[3].prop
      }
      if (this.form.selectReportId.length === 3 && this.colorId === 3) {
        newArr[4].slotName = newArr[4].prop
      }
      newArr &&
        newArr.push({
          label: 'Action',
          slotName: 'action',
          width: '200px',
        })
      return newArr
    },
    async handleClickCalcRate() {
      const { currency, exchangeRate } = this.modelForm
      if (currency && exchangeRate) {
        this.conversionRate = exchangeRate
        await this.getAllData({ showCurrency: 2, currency: 3 })
        this.isShowExchangeRate = false
      } else {
        this.$message.warning('Please select')
      }
    },
    async _getCurrenyRate() {
      const { rate } = await getCurrenyRate(
        this.modelForm.exchangeDate,
        this.modelForm.currency,
      )
      this.modelForm.exchangeRate = rate
    },
    async _getCurrencyList() {
      try {
        this.selectCurrencyList = await getCurrencyList()
      } catch (err) {
        console.error(err)
      }
    },
    async handleClickAverage(boolean) {
      if (this.selectReportData.length) {
        this.isAverageData = boolean
        await this.getAllData()
      }
    },
    async getAllData(data = {}) {
      console.log('getAllData', data)
      const typeList = {
        one: 1,
        two: 2,
        three: 3,
        four: 4,
        five: 5,
      }

      const selectReportId = (this.form && this.form.selectReportId) || []
      if (!selectReportId.length) {
        // no selection -> reset and return
        this.chartData = []
        this.existedKeys = []
        this.notifications = []
        this.cashflows = []
        this.cashflowsIds = []
        this.financeBalances = []
        this.financeBalancesIds = []
        this.financeIncomes = []
        this.financeIncomesIds = []
        this.financeRatios = []
        this.financeRatiosIds = []
        return
      }

      const params = {
        type: typeList[this.activeTab] || 1,
        exchangeRate: this.conversionRate,
        showCurrency: (data && data.showCurrency) || 1,
        showAverage: this.isAverageData ? 1 : 2,
        currency: (data && data.currency) || this.currency,
      }

      if (selectReportId.length > 1) params.financeIds = [...selectReportId]
      else params.financeId = selectReportId[0]

      try {
        const result = (await getMultipleData(params)) || {}
        this.analysisAiVO = result.analysisAiVO || {}
        const analysisVO = result.analysisVO || {}
        const chartsVO = result.chartsVO || {}

        const chartValues = Object.values(chartsVO || {})
        const _chartData = chartValues.map(item => {
          const clone = item ? { ...item } : { chartData: [] }
          if (!Array.isArray(clone.chartData) || clone.chartData.length === 0) {
            clone.chartData = [{ year: dayjs().year(), value: 0 }]
          }
          return clone
        })

        this.chartData = _chartData
        this.existedKeys = _chartData.map(i => i.fieldName)

        const {
          cashflows = [],
          financeBalances = [],
          financeIncomes = [],
          financeRatios = [],
          notifications = [],
        } = analysisVO || {}

        this.notifications = notifications

        const safeSlice = arr => (Array.isArray(arr) && arr.length ? arr.slice(0, arr.length - 1) : [])
        const safeLastIds = arr => {
          if (!Array.isArray(arr) || !arr.length) return []
          const last = arr[arr.length - 1]
          if (Array.isArray(last) && last[0] && last[0].financeIds) return last[0].financeIds
          return []
        }

        this.cashflows = safeSlice(cashflows)
        this.cashflowsIds = safeLastIds(cashflows)

        this.financeBalances = safeSlice(financeBalances)
        this.financeBalancesIds = safeLastIds(financeBalances)

        this.financeIncomes = safeSlice(financeIncomes)
        this.financeIncomesIds = safeLastIds(financeIncomes)

        this.financeRatios = safeSlice(financeRatios)
        this.financeRatiosIds = safeLastIds(financeRatios)
      } catch (err) {
        console.error('getAllData error:', err)
        // reset to safe defaults
        this.chartData = []
        this.existedKeys = []
        this.notifications = []
        this.cashflows = []
        this.cashflowsIds = []
        this.financeBalances = []
        this.financeBalancesIds = []
        this.financeIncomes = []
        this.financeIncomesIds = []
        this.financeRatios = []
        this.financeRatiosIds = []
      }
    },

    async handleClickComparisonViewBtn() {
      this.colorId = this.form.selectReportId.length
      // this.currency = ''
      if (!this.currency) {
        this.$message.warning('Please select Currency')
        return
      }
      await this.getAllData({ showCurrency: this.currency === 'USD' ? 1 : 2 })
    },
    async handleExportData() {
      const result = this.currencyList.filter(
        item => item.value === this.currency,
      )[0]
      const params = {
        type:
          this.activeTab === 'one'
            ? 1
            : this.activeTab === 'two'
            ? 2
            : this.activeTab === 'three'
            ? 3
            : 4,
        exchangeRate: this.conversionRate,
        showCurrency: result.label === 'USD' ? 1 : 2,
        currency: result.value,
      }
      if (this.isSelectedReportIds.length > 1) {
        params.financeIds = this.isSelectedReportIds
        params.showAverage = 2
      } else {
        params.financeId =
          this.form.selectReportId.join() || this.isSelectedReportIds.join()
        params.showAverage = this.isAverageData ? 1 : 2
      }
      await downLoadSelectReport(params)
      this.$message.success('success')
    },
    setCurrencyList(ids) {
      if (ids.length > 1) {
        // 处理多选
        const filterArr = []
        for (const id of ids) {
          const list = this.selectReportData.filter(item => item.id === id)
          if (list.length) {
            filterArr.push(list[0])
          }
        }
        const index = filterArr.findIndex(item => item.currency === 'USD')
        if (index !== -1) {
          this.currencyList = [
            {
              value: 'USD',
              label: 'USD',
              exchangeRate: 1,
            },
          ]
          return
        }

        const target = filterArr[0].currency
        const isEqual = filterArr.every(
          currentValue => currentValue.currency === target,
        )

        if (isEqual) {
          // select Exchange Date弹窗赋值本币币种
          this.modelForm.currency = target
          this.currencyList = [
            {
              value: 'USD',
              label: 'USD',
              exchangeRate: 1,
            },
            {
              value: target,
              label: target,
              exchangeRate: filterArr[0].exchangeRate,
            },
            {
              value: 3,
              label: 'Select Exchange Date',
            },
          ]
        } else {
          this.currencyList = [
            {
              value: 'USD',
              label: 'USD',
              exchangeRate: 1,
            },
          ]
        }
      } else if (ids.length === 1) {
        // 处理单选
        const result = this.selectReportData.filter(
          item => item.id === ids[0],
        )[0]
        if (result.currency === 'USD') {
          this.currencyList = [
            {
              value: 'USD',
              label: 'USD',
              exchangeRate: 1,
            },
          ]
          return
        }
        this.currencyList = [
          {
            value: 'USD',
            label: 'USD',
            exchangeRate: 1,
          },
          {
            value: result.currency,
            label: result.currency,
            exchangeRate: result.exchangeRate,
          },
          {
            value: 3,
            label: 'Select Exchange Date',
          },
        ]
        this.modelForm.currency = result.currency
      }
    },
    handleClickReport(isSelectedIds) {
      if (isSelectedIds.length === 0) {
        this.currency = ''
        this.currencyList = []
      }
      if (isSelectedIds.length > 1) {
        this.isShowComparisonBtn = true
        this.isShowSearchBtn = false
        this.isMultiple = false
        this.setCurrencyList(isSelectedIds)
      } else {
        this.isShowComparisonBtn = false
        this.isShowSearchBtn = true
        this.isMultiple = true
        this.setCurrencyList(isSelectedIds)
      }
      this.isSelectedReportIds = isSelectedIds
      const arr = []
      this.isSelectedReportIds.forEach(isSelectedId => {
        const list = this.selectReportData.filter(
          item => item.id === isSelectedId,
        )
        arr.push(list[0])
        this.selectedReportArr = arr
        if (list[0].attachmentId) {
          this.dataSource = 'Linkredit'
        } else {
          this.dataSource = 'CRMZ'
        }
        this.accountType = list[0].accountType
        this.auditorsOpinion = list[0].auditorsOpinion
      })
    },
    async _getTableData(params) {
      try {
        const { data, page } = await getReportTableData({
          ...params,
          companyId: this.$route.params.customerId,
        })

        this.tablePage = page

        this.selectReportData = data
        // 处理客户没有财报的情况
        if (this.selectReportData.length) {
          this.currency = 'USD'
          if (this.selectReportData[0].currency === 'USD') {
            this.currencyList = [
              {
                value: 'USD',
                label: 'USD',
                exchangeRate: 1,
              },
            ]
          } else {
            this.modelForm.currency = this.selectReportData[0].currency
            this.currencyList = [
              {
                value: 'USD',
                label: 'USD',
                exchangeRate: 1,
              },
              {
                value: this.selectReportData[0].currency,
                label: this.selectReportData[0].currency,
                exchangeRate: this.selectReportData[0].exchangeRate,
              },
              {
                value: 3,
                label: 'Select Exchange Date',
              },
            ]
          }
          if (this.selectReportData[0].attachmentId) {
            this.dataSource = 'Linkredit'
          } else {
            this.dataSource = 'CRMZ'
          }
          this.accountType = this.selectReportData[0].accountType
          this.auditorsOpinion = this.selectReportData[0].auditorsOpinion
          const selectReportIds = []
          selectReportIds.push(this.selectReportData[0].id)
          this.form.selectReportId = selectReportIds
          this.selectReportData.map(item => {
            if (item.reportQuarter === null) {
              item.reportQuarter = ''
            }
            this.QList.forEach(i => {
              if (item.reportQuarter === i.id) {
                item.reportQuarter = i.name
              }
            })
          })
        }
      } catch (err) {
        console.error(err)
      }
    },
    filterNameAccountType(status) {
      switch (status) {
        case 1:
          return 'Consolidated'
        case 2:
          return 'Stand alone'
      }
    },
    filterNameAuditorsOpinion(status) {
      switch (status) {
        case 1:
          return 'Unqualified'
        case 2:
          return 'With Remarks'
        case 3:
          return 'Qualified'
        case 4:
          return 'Non-audited'
      }
    },
    async handleCurrencyChange(currency) {
      if (currency !== 3) {
        const result = this.currencyList.filter(
          item => item.value === currency,
        )[0]
        this.conversionRate = result.exchangeRate
      }
      this.isShowExchangeRate = currency === 3
    },
    async handleTabChange() {
      console.log('handleTabChange')
      if (this.selectReportData.length) {
        if (this.currency !== 3) {
          const result = this.currencyList.filter(
            item => item.value === this.currency,
          )[0]
          this.conversionRate = result.exchangeRate
          await this.getAllData({
            showCurrency: result.label === 'USD' ? 1 : 2,
            currency: result.label,
          })
        } else {
          await this.getAllData({
            showCurrency: 2,
            currency: 3,
          })
        }
      }
    },
    async _handleChart(obj) {
      try {
        let type = ''
        let editDataIds = []
        if (this.activeTab === 'one') {
          type = 1
          editDataIds = this.financeIncomesIds
        } else if (this.activeTab === 'two') {
          editDataIds = this.financeBalancesIds
          type = 2
        } else if (this.activeTab === 'three') {
          editDataIds = this.financeRatiosIds
          type = 3
        } else {
          editDataIds = this.cashflowsIds
          type = 4
        }
        const financeIds = this._getEditIndex(editDataIds).map(item => item.id)
        const result = this.currencyList.filter(
          item => item.value === this.currency,
        )[0]
        const params = {
          financeIds: financeIds,
          type: type,
          fieldName: obj.row.key0,
          showCurrency: result.label === 'USD' ? 1 : 2,
          currency: result.value,
          exchangeRate: result.exchangeRate,
        }
        const res = await getTheChart(params)
        if (this.chartData.length < 3) {
          this.chartData.push(res)
          this.chartData = [].concat(...this.chartData)
          this.existedKeys = this.chartData.map(obj => obj.fieldName)
        } else {
          this.chartData.splice(this.chartData.length - 1, 1, res)
          this.existedKeys = this.chartData.map(obj => obj.fieldName)
        }
      } catch (err) {
        console.error(err)
      }
    },
    _handleReplace(obj) {
      const index = this.chartData.findIndex(
        item => item.fieldName === obj.key0,
      )
      if (index !== -1) {
        this.chartData.splice(index, 1)
        this.existedKeys = this.chartData.map(obj => obj.fieldName)
      }
    },
    // 查找可以修改的索引(主要是为了排除平均值，平均值不可以修改)
    _getEditIndex(data) {
      const indexArr = []
      data.forEach((item, index) => {
        if (item !== null) {
          indexArr.push({
            id: item,
            index,
          })
        }
      })
      return indexArr
    },
    // action - edit
    _handleEdit(row, tableIndex, activeTab) {
      var editDataIds = []
      var editData = []
      if (activeTab === 'one') {
        editDataIds = this.financeIncomesIds
        editData = this.financeIncomes
      } else if (activeTab === 'two') {
        editDataIds = this.financeBalancesIds
        editData = this.financeBalances
      } else if (activeTab === 'three') {
        editDataIds = this.financeRatiosIds
        editData = this.financeRatios
      } else {
        editDataIds = this.cashflowsIds
        editData = this.cashflows
      }
      const indexArr = this._getEditIndex(editDataIds)
      // 点击的 table 索引
      const clickTableIndex = tableIndex - 1 //数组的第几项
      // 点击的 table item 索引
      const clickTableItemIndex = row.$index + 1 //行数
      // 是否显示平均值
      const yearObj = editData[clickTableIndex][0] //第一行
      const yearKey = Object.keys(yearObj)[0] //属性
      const valueObj = editData[clickTableIndex][clickTableItemIndex]
      const valueKey = Object.keys(valueObj)[0] //属性
      // 初始年份
      const originalYearList = yearObj[yearKey] //年份
      this.fieldName = valueKey
      // 初始年份的值
      const originalYearValue = valueObj[valueKey]
      for (let index = 0; index < this.editDialogForm.length; index++) {
        this.editDialogForm[index] = {}
      }
      indexArr.forEach(item => {
        const { index } = item
        const obj = {
          value: originalYearValue[index],
          label: originalYearList[index],
        }
        this.editDialogForm.push(obj)
      })
      this.showDialog = true
    },
    // confirm
    async _handleConfirm() {
      for (let index = 0; index < this.editDialogForm.length; index++) {
        const element = this.editDialogForm[index]
        if (element.value === '') {
          this.$message.warning('Content cannot be empty')
          break
        }
      }
      let type = ''
      let editDataIds = []
      if (this.activeTab === 'one') {
        type = 1
        editDataIds = this.financeIncomesIds
      } else if (this.activeTab === 'two') {
        editDataIds = this.financeBalancesIds
        type = 2
      } else if (this.activeTab === 'three') {
        editDataIds = this.financeRatiosIds
        type = 3
      } else {
        editDataIds = this.cashflowsIds
        type = 4
      }
      const financeIds = this._getEditIndex(editDataIds).map(item => item.id)
      const values = this.editDialogForm.map(item => (item = item.value))
      const result = this.currencyList.filter(
        item => item.value === this.currency,
      )[0]
      await editData({
        financeIds,
        values,
        type,
        fieldName: this.fieldName,
        exchangeRate: result.exchangeRate,
        showCurrency: result.label === 'USD' ? 1 : 2,
        currency: result.label,
      })
      this.showDialog = false
      this.editDialogForm = []
      await this.getAllData()
    },
    handleSearch() {
      if (!this.form.selectReportId.length) {
        this.$message.warning('Please select Report')
        return
      }
      if (!this.currency) {
        this.$message.warning('Please select Currency')
        return
      }
      if (this.currency === 'USD') {
        this.getAllData()
      } else {
        this.getAllData({ showCurrency: 2 })
      }
    },
    _handleEditCancel() {
      this.showDialog = false
      this.editDialogForm = []
    },
    _handleEditClose() {
      this.editDialogForm = []
    },
    async handleCallAIInterface() {
      // 设置表单默认值为当前已选择的报告
      this.aiUpdateForm.reportIds = [...this.form.selectReportId] || [];
      this.aiUpdateForm.currency = this.currency || 'USD';

      // 显示对话框
      this.showAiUpdateDialog = true;
    },
    async handleAiUpdateSubmit() {
      if (!this.aiUpdateForm.reportIds || this.aiUpdateForm.reportIds.length === 0) {
        this.$message.warning('Please select at least one report');
        return;
      }

      if (!this.aiUpdateForm.currency) {
        this.$message.warning('Please select a currency');
        return;
      }

      try {
        // 处理中禁用按钮
        this.isAiButtonDisabled = true;
        this.showAiUpdateDialog = false;

        // 使用选择的参数调用AI接口
        await callAIInterface({
          aiFinanceIds: this.aiUpdateForm.reportIds,// 传递多个ID
          currency: this.aiUpdateForm.currency,
        })

        this.$message.success('AI analysis update initiated successfully');

        // 刷新AI分析数据
        await this._getAiAnalysis();
      } catch (error) {
        console.error('Error calling AI interface:', error);
        this.$message.error('Error calling AI interface: ' + (error.message || 'Network error'));
      } finally {
        // 3秒后重新启用按钮
        setTimeout(() => {
          this.isAiButtonDisabled = false;
        }, 3000);
      }
    },
  },
}
</script>

<style scoped lang="scss">
._container {
  min-width: 100%;
  height: 100%;
  ._card {
    margin-bottom: 20px;
  }
}
.actionBtn {
  text-align: end;
  position: relative;
}
.popover_class {
  margin-right: 20px;
}
._selectCurrency {
  margin: 0 58px 0 0;
}
.col_margin {
  margin-bottom: 10px;
  color: #606266;
  font-size: 14px;
}
.col_row {
  color: #606266;
  font-size: 14px;
}
</style>
